import { Component, HostListener, Input } from '@angular/core';
import { environment } from '../../../../../../public/environments/environment';

@Component({
  selector: 'app-header',
  standalone: false,
  templateUrl: './header.component.html'
})
export class HeaderComponent {
  lang = localStorage.getItem('language') || 'ar';
  @Input() isHome = true;
  isFixed: boolean = false;
  menuOpened = false;
  env = environment;

  changeLanguage() {
    if (localStorage.getItem('language') === 'en') {
      localStorage.setItem('language', 'ar');
    } else {
      localStorage.setItem('language', 'en');
    }
    window.location.reload();
  }

  @HostListener('window:scroll', []) onWindowScroll() {
    this.isFixed = window.scrollY > (window.innerHeight * 0.1);
  }
}
